import { render, staticRenderFns } from "./change-phone-number.vue?vue&type=template&id=b75f1f32&"
import script from "./change-phone-number.vue?vue&type=script&lang=js&"
export * from "./change-phone-number.vue?vue&type=script&lang=js&"
import style0 from "./change-phone-number.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports